const zIndices = {
  header: 100,
  modal: 1000,
  popover: 1500,
  tooltip: 2000,
}

export default zIndices
